import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12" }
const _hoisted_4 = {
  class: "container small",
  style: {"margin-top":"30px"},
  "data-test-id": "SigninView"
}
const _hoisted_5 = { class: "border-box" }
const _hoisted_6 = ["href"]

import { onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SessionExpiredPage',
  setup(__props) {

    const route = useRoute()

    onMounted(() =>
    {
        document.title = 'Session expired'
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "fg-color-blue" }, "Your session expired", -1 /* CACHED */)),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: `/organizations/sessions/new?returnUrl=${_unref(route).params.returnUrl}`,
                class: "btn btn-warning"
              }, " Start a new session ", 8 /* PROPS */, _hoisted_6)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})